export default __webpack_public_path__ + "static/gradient-f0c75c7f2fad95511aee63e5fcfe09ee.jpg";